//initial redux
import { put, call, takeEvery, fork, all, take, takeLatest, select } from "redux-saga/effects";
import { delay } from "redux-saga";
import config from "../../boot/config";
import pointservice from "../../services/points";
import {types as sitetreetypes} from "../../services/SiteTree/redux";

const initialState = {
    currentTariff: null,
    isBusy: true,
    errors: [],
    tariffsList: [],
    currentTariffVersion: null,
};

/////////
//types
export const types = {
    SET_TARIFF: "components/tariffs/SET_TARIFF",
    GET_TARIFFS: "components/tariffs/GET_TARIFFS",
    SEARCH_TARIFFS: "components/tariffs/SEARCH_TARIFFS",
    SET_TARIFF_VERSION: "components/tariffs/SET_TARIFF_VERSION",
};

///////////
//reducers
export const reducers = {
    reducer(state = initialState, action) {
        switch (action.type) {
            case types.SET_TARIFF: {
                return {...state, currentTariff: action.payload.tariff};
            }
            case types.GET_TARIFFS: {
                return { ...state, tariffsList: action.payload.tariffsList };
            }
            case types.SET_TARIFF_VERSION: {
                return { ...state, currentTariffVersion: action.payload }
            }
            default:
                return state;
        }
    }
};

//////////
//sagas
export const sagas = {
    *rootSaga() {
        yield all([
            this.refreshTariffOnSiteChange(),
            this.searchTariffs(),
            this.onSetTariff(),
        ]);
    },
    *onSetTariff() {
        yield takeEvery(types.SET_TARIFF, function*({payload}) {
            if(payload) {
                if(payload.tariff && payload.tariff.tariffVersion) {
                    yield put(actions.setTariffVersion(payload.tariff.tariffVersion));
                }
            }
        });
    },
    *refreshTariffOnSiteChange(){
        yield takeLatest([sitetreetypes.SET_CURRENT_SITE, sitetreetypes.ON_LOAD], function*({payload}){
            const currentTariff = yield select(s => s.tariffs.currentTariff);
            const currentTariffId = currentTariff ? currentTariff.tariffId : -1;
            if(!payload.currentSite.tariffId){
                    yield put(actions.setTariff(null));
            }else if(payload.currentSite.tariffId !== currentTariffId){
                    const newTariff = yield call(pointservice.TariffGetDetails, payload.currentSite.tariffId);
                    yield put(actions.setTariff(newTariff));
            }
        });
    },
    *searchTariffs() {
        yield takeLatest(types.SEARCH_TARIFFS, function* () {
            let currentSite = yield select(x => x.sitetree.currentSite);
            if (!currentSite) {
                const _action = yield take(sitetreetypes.ON_LOAD);
                currentSite = _action.payload.currentSite;
            }
            if (currentSite.tariffId && currentSite.tariffId > 0) {
                const tariffsList = yield call(pointservice.TariffGetVersions, currentSite.tariffId);
                if (tariffsList instanceof Error) {
                    console.error(tariffsList);
                    yield put(
                        actions.genericAction(types.ON_GET_FRIENDS_FAILED, tariffsList)
                    );
                } else {
                    yield put(actions.getTariffs(tariffsList));
                }
            } else {
                yield put(actions.getTariffs([]));
            }
        });
    },
};

////////
//actions
export const actions = {
    setTariff(tariff){
        return {
            type: types.SET_TARIFF,
            payload: {tariff}
        };
    },
    setTariffVersion(payload) {
        return {
            type: types.SET_TARIFF_VERSION,
            payload
        }
    },
    getTariffs(tariffsList) {
        return {
            type: types.GET_TARIFFS,
            payload: { tariffsList }
        };
    },
    searchTariffs() {
        return {
            type: types.SEARCH_TARIFFS,
            payload: {}
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Tariffs/redux.js